import { getLangFromRoute } from '../../shared/languageHelpers';

/**
 * @param {{name: string, email: string, password?: string, currentUrl: string}} textInputData
 * @return {URLSearchParams}
 */
export default function createFormData({
  name,
  email,
  password,
  currentUrl,
  recaptchaToken,
}) {
  const formData = new URLSearchParams();
  if (password) {
    formData.append('pass', password);
  }

  formData.append('g-recaptcha-response', recaptchaToken);
  formData.append('user_given_name', name);
  formData.append('email', email);
  formData.append('platform', 'web');
  formData.append('user_language', getLangFromRoute(currentUrl));
  return formData;
}
